import cx from 'classnames';
import {Button} from '~library/atoms/Button';
import {Link} from '~library/atoms/Link';

export const MenuItem = ({
  index,
  action,
  href,
  children,
  disabled,
  dataQaId = '',
  danger = false,
}) => (
  <div className="menu-content__item">
    {href ? (
      <Link
        as="transparent"
        className={cx('menu-content__item__button', {danger})}
        data-qa-id={`${dataQaId}-${index}`}
        href={href}
        disabled={disabled}
      >
        {children}
      </Link>
    ) : (
      <Button
        variant="unstyled-button"
        className={cx('menu-content__item__button', {danger})}
        data-qa-id={`${dataQaId}-${index}`}
        onClick={() => action(index)}
        disabled={disabled}
      >
        {children}
      </Button>
    )}
  </div>
);
